module.exports = __webpack_public_path__ + "assets/cupboard.3d0ae2e9.svg";